import React from 'react';

export default function StatsSection() {
    const stats = [
        { label: 'Client Success Partnerships', value: '10+', description: 'End-to-end management with 100% project delivery.' },
        { label: 'Full-Stack Solutions', value: '15+', description: 'Robust applications across diverse industries.' },
        { label: 'Uptime Reliability', value: '99.9%', description: 'Managed hosting with unparalleled stability.' },
        { label: 'Deployment Success', value: '100%', description: 'Zero-downtime deployment pipelines implemented.' },
    ];

    return (
        <section className="bg-white py-20 px-6 lg:px-20 border-t border-gray-100">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-16">
                    <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                        Proven track record of digital excellence
                    </h2>
                    <p className="text-xl text-gray-500 max-w-2xl mx-auto">
                        We don't just build websites; we manage growth and ensure your technology stack is always performing at its peak.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
                    {stats.map((stat, index) => (
                        <div key={index} className="p-8 rounded-3xl bg-gray-50 hover:bg-blue-50 transition-colors duration-300 group">
                            <div className="text-5xl font-bold text-blue-600 mb-2 group-hover:scale-105 transition-transform duration-300 inline-block">
                                {stat.value}
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-3">{stat.label}</h3>
                            <p className="text-gray-500 leading-relaxed">{stat.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
